import React, { useContext, useState, useEffect } from 'react';

import {
    CssBaseline,
    TextField
} from '@material-ui/core';

import {
    PageFooter
} from '../common';


import { makeStyles, useTheme } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2)
    }
}));

export const Layout = ({ ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <div className={classes.root}>
            {/* <CssBaseline /> */}
            <main className={classes.content}>
                {props.children}
                <PageFooter />
            </main>
        </div>
    );
}